// extracted by mini-css-extract-plugin
export var closeButton = "_6-1";
export var container = "_6-0";
export var fullModalImage = "_6-2";